import { CourseGroupUserProgressRow } from 'sierra-domain/api/manage'

export const isSelfStarted = (groupUserProgressRow: CourseGroupUserProgressRow): boolean =>
  groupUserProgressRow.programs.length === 0 && !groupUserProgressRow.createdAt
